import * as React from 'react';
import {
    SaveButton,
    SimpleForm,
    TextInput,
    Toolbar,
    required,
    useNotify,
    useRefresh,
    FileInput,
    FileField,
} from 'react-admin';
import Dialog from '@mui/material/Dialog';
import { config } from '../../config';
import { getJwtHeader } from '../../auth/authProvider';
import { convertFileToBase64 } from '../../data-provider-with-image-convert';
import { UniqueRequestMessage } from '../../models/unique-request';

const MessageToolbar = () => {
    return (
        <Toolbar>
            <SaveButton label="Mentés" />
        </Toolbar>
    );
};

export const UniqueRequestMessageEditDialog = ({
    message,
    open,
    setOpen,
}: {
    message: UniqueRequestMessage;
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const notify = useNotify();
    const refresh = useRefresh();

    const defaultValues = {
        content: message.content,
        attachments:
            message.attachments?.map((attachment) => ({
                title: attachment.name,
                src: attachment.url,
            })) ?? [],
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            PaperProps={{
                style: { maxWidth: 750 },
            }}
        >
            <SimpleForm
                defaultValues={defaultValues}
                toolbar={<MessageToolbar />}
                onSubmit={async (values) => {
                    const files = values.attachments ?? [];
                    const attachments = await Promise.all(
                        files.map(async (file: any) => {
                            if (file.rawFile instanceof File) {
                                return {
                                    name: file.title,
                                    url: await convertFileToBase64(file),
                                };
                            }

                            return {
                                name: file.title,
                                url: file.src,
                            };
                        })
                    );

                    const response = await fetch(
                        `${config.apiUrl}/unique-request/${message.uniqueRequestId}/message/${message.id}`,
                        {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: getJwtHeader(),
                            },
                            body: JSON.stringify({
                                content: values.content,
                                attachments: attachments,
                            }),
                        }
                    );

                    if (!response.ok) {
                        const message = await response.text();
                        notify(message, { type: 'error' });
                        return;
                    }

                    notify('Sikeres módosítás', { type: 'success' });
                    refresh();
                    setOpen(false);
                }}
            >
                <TextInput
                    source="content"
                    label={'Üzenet'}
                    fullWidth
                    multiline
                    validate={required()}
                    minRows={10}
                />
                <FileInput
                    source="attachments"
                    name={'attachments'}
                    multiple
                    label={'Csatolmányok'}
                >
                    <FileField source="src" title="title" />
                </FileInput>
            </SimpleForm>
        </Dialog>
    );
};
